import styled, { css } from "styled-components/macro";
import type { Layout } from "styles/elements/ElementsInterface";

export const ParagraphCss = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.regular};
  font-size: ${(props: Layout) => props.theme.font.size._14};
  line-height: ${(props: Layout) => props.theme.font.size._14};
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
`;

export const Paragraph = styled.p<Layout>`
  ${ParagraphCss}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;

export const ParagraphBold = styled.p<Layout>`
  ${ParagraphCss}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
`;

export const ParagraphBanner = styled.p<Layout>`
  font-size: 1.1rem;
  letter-spacing: 0;
  line-height: 1.2rem;
  margin: 0.7rem 1rem 0 0
`;
